import { normalizeText } from "../../shared/util/normalizeText";
import { Fixations } from "../../shared/data/types";

export const getFixationName = (v: string): Fixations => {
  const normValue = normalizeText(v);

  if (
    normValue?.includes("ceramica") ||
    normValue?.includes("ceramico") ||
    normValue?.includes("colonial") ||
    normValue === "telhado"
  ) {
    return "Cerâmica";
  }

  if (
    (normValue?.includes("fibrocimento") && normValue?.includes("metal")) ||
    normValue?.includes("fibrometal")
  ) {
    return "Fibrocimento Est. Metálica";
  }

  if (
    (normValue?.includes("fibrocimento") && normValue?.includes("madeira")) ||
    normValue === "fibrocimento"
  ) {
    return "Fibrocimento Est. Madeira";
  }

  if (normValue?.includes("metal") && normValue?.includes("ondul")) {
    return "Metálica Ondulada";
  }

  if (normValue?.includes("metal") && normValue?.includes("55")) {
    return "Metálica 55cm";
  }

  if (
    (normValue?.includes("metal") && normValue?.includes("trapez")) ||
    normValue === "metalica" ||
    normValue === "metalico" ||
    (normValue?.includes("metal") && !normValue?.includes("ondul"))
  ) {
    return "Metálica Trapezoidal";
  }

  if (normValue?.includes("mini") && normValue?.includes("trilho")) {
    return "Mini Trilho";
  }

  if (
    normValue?.includes("shingle") ||
    normValue?.includes("americano") ||
    normValue?.includes("americana")
  ) {
    return "Americano";
  }

  if (normValue?.includes("zipado") || normValue?.includes("zipada")) {
    return "Zipado";
  }

  if (normValue?.includes("laje")) {
    return "Laje";
  }

  if (normValue?.includes("solo")) {
    return "Solo";
  }

  if (normValue?.includes("kalhetao")) {
    return "Kalhetão";
  }

  if (normValue?.includes("carport")) {
    return "Carport";
  }

  if (normValue?.includes("sem estrutura")) {
    return "Sem Estrutura";
  }
};
